import type { HomeConfig, Policy, Selector } from 'types';

export const getPermissionsPolicy: Selector<Policy> = (state) => state.permissions.policy;

export const getUserHome: Selector<HomeConfig> = (state) => state.permissions.home;
